module.exports = __webpack_public_path__ + "static/media/set_Bunny_Friends.7e90e33f.jpg";